import { render, staticRenderFns } from "./IdentityClaims.vue?vue&type=template&id=59a3ee42&"
import script from "./IdentityClaims.vue?vue&type=script&lang=js&"
export * from "./IdentityClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports